import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Flame } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { IMAGES } from "@/lib/images";

export const Prophetic = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);

  return (
    <section
      ref={ref}
      id="mantle"
      data-testid="prophetic-section"
      className="relative py-24 sm:py-32 bg-ink text-parchment grain overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-80"
        style={{
          background:
            "radial-gradient(circle at 75% 35%, rgba(197,80,20,0.22), transparent 45%), radial-gradient(circle at 10% 90%, rgba(197,160,89,0.12), transparent 45%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <Reveal>
            <div className="flex items-center gap-3">
              <Flame className="text-orange-400" size={20} />
              <Overline>The Mantle</Overline>
            </div>
            <h2 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[0.95]">
              Apostle.
              <br />
              <span className="gold-foil">Prophetic Intercessor.</span>
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <p className="mt-7 max-w-xl text-base sm:text-lg leading-relaxed text-parchment/80">
              Charles McKuhn carries an apostolic and prophetic mantle, moving
              under the authority and unction of the Holy Ghost. As a prophetic
              intercessor he stands in the gap for families, cities, and
              nations — contending in prayer, releasing the word of the Lord,
              and calling the Church into revival fire.
            </p>
          </Reveal>

          <Reveal delay={0.2}>
            <blockquote className="mt-8 border-l-2 border-gold/60 pl-5 font-serif text-xl italic text-parchment/90">
              “The Lion of the tribe of Judah has prevailed.”
            </blockquote>
          </Reveal>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <Reveal>
            <div className="relative mx-auto max-w-md">
              <div className="absolute -inset-3 border border-orange-500/30 rounded-[2rem] translate-x-4 translate-y-4" />
              <motion.div
                style={{ y }}
                className="relative overflow-hidden rounded-[2rem] border border-gold/30"
              >
                <img
                  src={IMAGES.lion}
                  alt="Charles McKuhn riding a lion of fire — prophetic imagery"
                  className="w-full h-[520px] sm:h-[620px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
              </motion.div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
